import io from 'socket.io-client';
import { network } from '../config';



const socket = io(network.socketApi);



/* 
Function used subscribe to new orders made
when admin user is authenticated.
This client socket listens for 'neworder' events
from the server then executes the callback function.


This function is used in App.js in the 
BackOfficeContentWrapper component.

*/
export function subscribeToOrders(callback, auth) {
    //subscribe to more events from the server here
    socket.on('neworder', (customer_name, customerid) => callback(customer_name));
    socket.on('newcontact', (customer_name, customerid) => callback(customer_name));
    if(auth.token !== ""){
        socket.emit('subscribetoOrder');
        //emit more events to the server here
        //telling the server what you want to subscribe to
    }
}

